import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import IconLoading from 'components/Common/Icons/IconLoading';
import getFamiliesOffset from 'store/category/selector/getFamiliesOffset';
import getTotalFamiliesAvailable from 'store/category/selector/getTotalFamiliesAvailable';
import getTotalFamiliesFetched from 'store/category/selector/getTotalFamiliesFetched';
import isCategoryLoading from 'store/category/selector/isCategoryLoading';
import isMoreFamiliesToFetch from 'store/category/selector/isMoreFamiliesToFetch';
import useCategoryURLParams from 'hooks/useCategoryURLParams';
import getCategoryPageNr from 'store/category/selector/getCategoryPageNr';
import styles from './LoadMoreItems.module.scss';

const LoadMoreItems = () => {
  const moreFaimilisToLoad = useSelector(isMoreFamiliesToFetch);
  const fetchedFamilies = useSelector(getTotalFamiliesFetched);
  const familiesOffset = useSelector(getFamiliesOffset);
  const totalFamilies = useSelector(getTotalFamiliesAvailable);
  const isLoading = useSelector(isCategoryLoading);
  const pageNr = useSelector(getCategoryPageNr);
  const { queryString } = useCategoryURLParams(pageNr + 1);

  const [fetchingPage, setFetchingPage] = useState(false);
  const { t } = useTranslation();

  const progressStyles = {
    transform: `translateX(${Math.round((familiesOffset + fetchedFamilies) / (totalFamilies * 100)) - 100}%)`,
  };

  useEffect(() => {
    if (isLoading && fetchingPage) {
      return () => {
        setFetchingPage(false);
      };
    }
    return () => {};
  }, [isLoading, fetchingPage]);

  if (!moreFaimilisToLoad) {
    return null;
  }

  const designsShowing = {
    number: fetchedFamilies + familiesOffset,
    total: totalFamilies,
  };

  return (
    <div className={styles.loadMoreItems}>
      <div className={styles.numberOfDesigns}>{t('txt_designs_showing', designsShowing)}</div>
      <div className={styles.progressBar}>
        <div className={styles.levelIndicator} style={progressStyles} />
      </div>
      <div className={styles.loadMoreButton}>
        {fetchingPage && <IconLoading className={styles.loadingIcon} />}
        <Link to={queryString} className={fetchingPage ? styles.hidden : ''}>
          {t('toggle_show_more_orderflow')}
        </Link>
      </div>
    </div>
  );
};

export default LoadMoreItems;
